export default __webpack_public_path__ + "efedca21c9077dd9438385784cf7fbf0.mp3";